/* eslint-disable prettier/prettier */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useAuth, handleLogin /* , handleGuestLogin */ } from "context/auth";
import { useNavigate } from "react-router-dom";
import { useLoading, handleLoading } from "context/LoadingContext";

function Login() {
  const [auth, dispatchAuth] = useAuth();
  const navigate = useNavigate();
  const [, loadingDispatch] = useLoading();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data) => {
    try {
      handleLoading(loadingDispatch, true);
      await handleLogin(dispatchAuth, data);
    } catch (error) {
      console.log(error);
    }
    handleLoading(loadingDispatch, false);
  };
  useEffect(() => {
    if (auth.isLoggedIn) navigate("/");
  }, [auth.isLoggedIn]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <h2>
        <img
          src={`${process.env.PUBLIC_URL}/ydeLogo.png`}
          alt="YDE"
          style={{ width: "80%" }}
        />
      </h2>
      {/* <h3>بوابة مديرية خدمات المستثمرين</h3> */}
      <Form.Group className="mb-3 input input-md" controlId="formLogin">
        <Form.Label style={{ textAlign: "start" }}>Username</Form.Label>
        <Form.Control
          autoComplete="false"
          type="text"
          {...register("username", {
            required: "الرجاء ادخال اسم المستخدم",
          })}
        />
        {errors.username && (
          <Form.Text className="text-danger">
            {errors.username.message}
          </Form.Text>
        )}
      </Form.Group>
      <Form.Group className="mb-4 input input-md" controlId="formBasicEmail">
        <Form.Label style={{ textAlign: "start" }}>Password</Form.Label>
        <Form.Control
          autoComplete="false"
          type="password"
          {...register(
            "password" /*  {
            minLength: { value: 6, message: "الحد الأدنى للحروف هو 6" },
            required: "الرجاء ادخال كلمة السر",
          } */
          )}
          style={{ fontFamily: "sans-serif" }}
        />
        {errors.password && (
          <Form.Text className="text-danger">
            {errors.password.message}
          </Form.Text>
        )}
      </Form.Group>

      <button
        type="submit"
        className=" btn btn--primary"
        style={{
          "--bg": "#ffcc00",
          color: "#023A6C",
          fontWeight: "500"
        }}
      >
        Login
      </button>
      {/* <button
        type="button"
        className="btn--outline"
        onClick={handleGuestLogin.bind(this, dispatchAuth)}
      >
        دخول كزائر
      </button> */}
    </form>
  );
}

export default Login;
